import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { aboutHighlights } from '@/mocks/homeData';

export default function AboutBekaali() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="w-full lg:w-1/2"
          >
            <div className="relative">
              {/* Main image */}
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20with%20African%20and%20Chinese%20business%20professionals%20collaborating%20around%20a%20conference%20table%2C%20diverse%20team%2C%20large%20windows%20with%20city%20view%2C%20warm%20natural%20light%2C%20professional%20atmosphere%2C%20premium%20editorial%20photography&width=800&height=600&seq=about-main&orientation=landscape"
                  alt="BEKAALI Team"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              {/* Floating badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="absolute bottom-4 right-4 md:-bottom-6 md:-right-6 bg-accent-500 text-primary-900 rounded-2xl px-5 py-4 md:px-6 md:py-5"
              >
                <div className="text-2xl md:text-3xl font-heading font-bold">5+</div>
                <div className="text-[10px] md:text-xs font-semibold uppercase tracking-wider mt-1">Years of<br />Excellence</div>
              </motion.div>

              {/* Decorative element */}
              <div className="absolute -top-6 -left-6 w-32 h-32 border-2 border-accent-200/50 rounded-2xl -z-10"></div>
            </div>
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
            className="w-full lg:w-1/2"
          >
            <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-600 mb-4">
              Who We Are
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6 leading-tight">
              Connecting Businesses,
              <br />
              <span className="text-primary-500">Creating Opportunities</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              BEKAALI ENTERPRISES LIMITED is a trusted trading, procurement, logistics, and supply chain solutions company committed to helping businesses source smarter, move faster, and grow confidently.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              We connect clients with reliable suppliers, quality products, and efficient logistics networks, delivering integrated solutions that simplify procurement and ensure every project is executed with professionalism and precision.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
              {aboutHighlights.map((stat, i) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
                  className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.number}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.4, delay: 0.7 }}
            >
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Learn More About Us
                <i className="ri-arrow-right-line"></i>
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}